var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    width: 54.6851,
    height: 54.5011,
    rx: 6.60502,
    transform: "matrix(0.940174 0.340694 -0.34335 0.939207 20.582 0)",
    fill: "url(#paint0_linear_13482_16056)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_13482_16056)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 17.5986,
    width: 54.7131,
    height: 54.473,
    rx: 6.60502,
    fill: "url(#paint1_radial_13482_16056)",
    fillOpacity: 0.62
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13482_16056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1832 51.017L37.9966 46.8304C36.5014 45.3352 33.9596 45.9333 33.3615 47.877C32.9129 49.2228 31.4177 49.9704 30.072 49.6713C27.0816 48.9237 23.0445 45.0361 22.2969 41.8962C21.8484 40.5504 22.7455 39.0552 24.0912 38.6067C26.035 38.0086 26.633 35.4668 25.1378 33.9716L20.9512 29.785C19.7551 28.7383 17.9608 28.7383 16.9142 29.785L14.0733 32.6259C11.2324 35.6163 14.3723 43.5409 21.3998 50.5684C28.4273 57.5959 36.3519 60.8854 39.3423 57.8949L42.1832 55.054C43.2299 53.8579 43.2299 52.0636 42.1832 51.017Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_13482_16056",
    x: -1.9815,
    y: 15.6171,
    width: 58.6779,
    height: 58.4362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.990752
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13482_16056"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13482_16056",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13482_16056",
    x: 13.0312,
    y: 29,
    width: 39.3555,
    height: 39.418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.709,
    dy: 4.709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3545
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13482_16056"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13482_16056",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13482_16056",
    x1: 11.4352,
    y1: 13.8397,
    x2: 67.0932,
    y2: 35.3658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E4C97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13482_16056",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3566 44.8351) rotate(90) scale(29.9602 30.0922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93A1ED",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93A1ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.9f7346302b289b0c7acaa3b9a46a916b.svg";
export { ForwardRef as ReactComponent };